import { Box, Typography } from '@mui/material'

const TabBadge = ({ count }) => {
    if (!count || count === 0) return null

    return (
        <Box
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                minWidth: '20px',
                height: '20px',
                borderRadius: '10px',
                backgroundColor: '#2666be',
                color: '#ffffff',
                fontSize: '12px',
                fontWeight: 600,
                marginLeft: '8px',
            }}
            >
            {count > 99 ? '99+' : count}

        </Box>
    )
}

export default TabBadge